import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { APP_CONFIG, BaseAppConfig } from './app.config';
import { AppComponent } from './app.component';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { FormsModule } from '@angular/forms';
import { InterceptorProvider } from 'src/services/Interceptor-provider.interceptor';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import * as Sentry from "@sentry/angular";
//import firebase from 'firebase/app';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import 'firebase/auth';
import 'firebase/firestore';
import { environment } from 'src/environments/environment';
import { APP_INITIALIZER } from "@angular/core";
import { Router } from "@angular/router";
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularFireModule } from "@angular/fire"
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { VehicleAttachmentComponent } from 'src/models/vehicle-attachment/vehicle-attachment.component';
import { WalletFilterComponent } from 'src/models/wallet-filter/wallet-filter.component';
import { HelpdeskAttachmentComponent } from 'src/models/helpdesk-attachment/helpdesk-attachment.component';
import { ServiceFilterComponent } from 'src/models/service-filter/service-filter.component';

import { IonCustomScrollbarModule } from 'ion-custom-scrollbar'

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    WalletFilterComponent,
    ServiceFilterComponent,
    HelpdeskAttachmentComponent,
    VehicleAttachmentComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule, 
    FormsModule, 
    HttpClientModule, 
    TranslateModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    NgSelectModule,
    IonCustomScrollbarModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],
  providers: [FileOpener,
    StatusBar,
    SplashScreen,
    SocialSharing,
    InAppBrowser,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: environment.sentryFeedbackUserDialog,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: APP_CONFIG, useValue: BaseAppConfig },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule { }
